import React, {useEffect,useState} from 'react'
import Header from 'components/Headers/Header'
import { Button, Card, CardBody, CardFooter, CardHeader, CardText, CardTitle, Col, Container, Input, Row } from 'reactstrap'
import {getCashUp,submitCashup,getCashUpBySeller} from 'network/ApiAxiosMerchShop'

function CashUp() {
    const [total, setTotal] = useState(0);
    const [money, setMoney] = useState(0);
    const [result, setResult] = useState(money-total);
    const [cashupSeller, setcashupSeller] = useState([]);

    useEffect(() => {
        getCashUpHandler()
        getCashUpBySellerHandler()
        moneyHandler()
    }, []);

    useEffect(() => {
        moneyHandler()
    }, [money]);

    const moneyHandler =()=>{
        setResult(money-total)
    }

    const getCashUpHandler =async()=>{
        const resp = await getCashUp()
        if(resp.data.success){
            setTotal(resp.data.total)
        }else{
            alert('error')
        }
    }

    const getCashUpBySellerHandler =async()=>{
        const resp = await getCashUpBySeller()
        if(resp.data.success){
            setcashupSeller(resp.data.test)
        }else{
            alert('error')
        }
    }

    const handleSubmit =()=>{
        const userID = JSON.parse(localStorage.getItem('user'))._id
        const resp = submitCashup(money,result,userID)
        if(resp.data.success){
            setMoney(0)
            setTotal(0)
        }
    }

  return (
    <>
    <Header/>
    <Container>
        <Card className='text-center' >
            <CardHeader>
                <CardTitle>Merch Shop Cash-up</CardTitle>
            </CardHeader>
            <CardBody>
                {
                    cashupSeller && cashupSeller.map((sellerItem)=>{
                        return <Row className=' border-1 border'>
                            <Col md={6}>
                                {sellerItem._id.name}
                            </Col>
                            <Col md={6}>
                                <strong>{sellerItem.finalTotal}€</strong>
                            </Col>
                        </Row>
                    })
                }
                <CardTitle>Total: {total}€</CardTitle>
                <Row>
                    <Col md={6}>
                        <Input type="number" value={money} onChange={(e)=>{setMoney(e.target.value)}} />
                    </Col>
                    <Col md={6}>
                        <h1 className={result > 0 ? 'bg-blue' : result == 0 ? 'bg-green' : 'bg-red'}>{result}€</h1>
                    </Col>
                </Row>
            </CardBody>
            <CardFooter>
                <Button onClick={()=>handleSubmit()} >Submit</Button>
            </CardFooter>
        </Card>
        
    </Container>
    </>
  )
}

export default CashUp